module.exports = __webpack_public_path__ + "img/qrcode-icon.69431a2d.svg";